const planetReveal = {
  title: "Planet Reveal",
  back: "Back",
  reconFailure: "Recon Failure",
  youAreNotPlanerOwner: "You are not the owner of Planet #",
};
export default planetReveal;
